import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";

interface FileUploadInputProps {
  label?: string;
  name: string;
  required?: boolean;
  formik: any;
  compact?: boolean;
  accept?: string; // optional
  existingFile?: boolean;
}

const FileUploadInput: React.FC<FileUploadInputProps> = ({
  label,
  name,
  required = false,
  formik,
  compact = false,
  accept,
  existingFile,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const file = formik.values[name];

  //*// Custom label
  const [displayName, setDisplayName] = useState<string>("");

  useEffect(() => {
    if (file) {
      setDisplayName(file.name);
    } else {
      setDisplayName("Upload File");
    }
  }, [file, existingFile]);

  const handleFileChange = (e: any) => {
    const selectedFile = e.currentTarget.files[0];
    formik.setFieldValue(name, selectedFile);
  };

  const handleRemove = () => {
    formik.setFieldValue(name, null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const triggerFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div
      className={compact ? "w-100" : "mb-4 w-100"}
      // style={{ border: "1px solid red" }}
    >
      {label && <Form.Label>{label}</Form.Label>}

      <div className="position-relative">
        <div
          className="d-flex align-items-center border rounded px-3 py-2"
          style={{
            height: "40px",
            backgroundColor: "#f9f9f9",
            borderColor: "#ced4da",
            position: "relative",
            zIndex: 1,
          }}
        >
          <Form.Control
            type="file"
            name={name}
            onChange={handleFileChange}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.errors[name] && formik.touched[name]}
            style={{ display: "none" }}
            ref={fileInputRef}
            accept={accept}
          />

          <span
            className="flex-grow-1 text-muted text-truncate"
            style={{
              fontSize: "13px",
              cursor: "pointer",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            onClick={triggerFileDialog}
            title={file ? file.name : "Upload File"}
          >
            {/* {displayName} */}
            {file && file.name && file.name.trim() !== ""
              ? file.name
              : "Upload File"}
          </span>

          {file ? (
            <span
              style={{
                cursor: "pointer",
                marginLeft: "10px",
                zIndex: 2,
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleRemove();
              }}
            >
              <i className="bi bi-x-lg"></i>
            </span>
          ) : (
            <span
              style={{ cursor: "pointer", zIndex: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                triggerFileDialog();
              }}
            >
              <i className="bi bi-upload"></i>
            </span>
          )}
        </div>

        <Form.Control.Feedback
          type="invalid"
          style={{ display: required ? "block" : "none" }}
        >
          {formik.errors[name]}
        </Form.Control.Feedback>
      </div>
    </div>
  );
};

export default FileUploadInput;
